export enum AuthResponseStatus {
  FAILED = 'Failed',
  SUCCESS = 'Success'
}
